<div class="form-title">
    <span class="subtitle">{{title}}</span>
</div>
<ng-container *ngIf="addForm;else noForm">
    <ubs-ofbiz-form [ofbizForm]="addForm" [parameters]="parameters" [title]="title" (openDialogContainerEvent)="openDialogContainer($event)" [lookupFieldResult]="lookupFieldResult" (submitResult)="submitResult($event)" [target]="target"></ubs-ofbiz-form>
</ng-container>
<ng-template #noForm>
    <p>There's no fucking form</p>
</ng-template>


